import { render, staticRenderFns } from "./new_pay.vue?vue&type=template&id=63828ee4&scoped=true&"
import script from "./new_pay.vue?vue&type=script&lang=js&"
export * from "./new_pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63828ee4",
  null
  
)

export default component.exports